import { Component } from '@angular/core';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';

@Component({
  selector: 'app-adminloader',
  templateUrl: './adminloader.component.html',
  styleUrls: ['./adminloader.component.scss']
})
export class AdminloaderComponent {

  constructor(public adminApi: AdminapiService) {
  }
}
